export default __webpack_public_path__ + "img/99c8556eb55560a981bceb98c6999cb3.png";